import { Injectable, NgZone, Optional } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs';

import type { TooltipDirective } from '../directives/tooltip.directive';

@Injectable({
    providedIn: 'root'
})
export class TooltipRegistryService {

    private tooltips = new Set<TooltipDirective>();

    constructor(
        private zone: NgZone,
        @Optional() private router: Router
    ) {
        this.router?.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.zone.runOutsideAngular(() => setTimeout(() => this.cleanUpDetachedTooltips()));
        });
    }

    register(tooltip: TooltipDirective): void {
        this.tooltips.add(tooltip);
    }

    unregister(tooltip: TooltipDirective): void {
        this.tooltips.delete(tooltip);
    }

    private cleanUpDetachedTooltips(): void {
        this.tooltips.forEach(tooltip => {
            if (!tooltip.el.nativeElement.isConnected) {
                if (tooltip.container) {
                    tooltip.deactivate();
                }
                this.tooltips.delete(tooltip);
            }
        });
    }
}
